import { FC } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { Popover } from 'antd';
import { IMainMenu } from '@modules/header/domain/models/menu.model';
import { analytics } from '@shared/utils/segment.utils';
import CategoryMenuLogic from './category/CategoryMenu.logic';
import { MainMenuContainer, MainMenuList } from './MainMenu.style';
import ActivitySubmenuLogic from './submenu/ActivitySubmenu.logic';
import HeaderMenu from './submenu/ArrowMenu';
interface Props {
  mainMenu: IMainMenu[];
  isGinARaiDeeOpen: boolean;
  setIsGinARaiDeeOpen: (val: boolean) => void;
  isNewsOpen: boolean;
  setIsNewOpen: () => void;
  closeAllModal: () => void;
}
const MainMenu: FC<Props> = ({
  mainMenu,
  isGinARaiDeeOpen,
  setIsGinARaiDeeOpen,
  isNewsOpen,
  setIsNewOpen,
  closeAllModal
}: Props) => {
  const router = useRouter();
  const pagePath = router.pathname;
  const onClickMenu = (menu: IMainMenu) => {
    analytics.track('Navigation Bar Click Menu', {
      event: 'Navigation Bar Click Menu',
      menu: menu.title
    });
  };
  const checkMenuTitle = (menu: IMainMenu) => {
    if (menu.id === mainMenu[0].id) {
      return <HeaderMenu title={menu.title} isOpen={isGinARaiDeeOpen} onClick={() => setIsGinARaiDeeOpen(!isGinARaiDeeOpen)} />;
    }
    if (menu.id === mainMenu[3].id) {
      return <Popover content={<ActivitySubmenuLogic />} trigger="click" placement="bottom" arrow={false} open={isNewsOpen}>
                    <HeaderMenu title={menu.title} isOpen={isNewsOpen} onClick={setIsNewOpen} />
                </Popover>;
    } else {
      return <Link href={menu.redirectTo} onClick={closeAllModal}>
                    {menu.title}
                </Link>;
    }
  };
  return <>
            {mainMenu.map((menu: IMainMenu) => {
      return <MainMenuContainer key={menu.id}>
                        <MainMenuList className={`${pagePath === menu.redirectTo ? 'active' : ''}`} onClick={() => onClickMenu(menu)}>
                            {checkMenuTitle(menu)}
                        </MainMenuList>
                    </MainMenuContainer>;
    })}
            <CategoryMenuLogic />
        </>;
};
export default MainMenu;